module.exports = __webpack_public_path__ + "static/media/earhear-2.4c2d71f3.jpg";